// extracted by mini-css-extract-plugin
var _1 = "custom-scroll-0e180";
var _2 = "display-settings__body-0e180";
var _3 = "display-settings__header-0e180";
var _4 = "hidden-scroll-0e180";
var _5 = "rankscale-0e180";
var _6 = "settings__description-0e180";
var _7 = "settings__label-0e180";
var _8 = "settings__subtitle-0e180";
var _9 = "signup-0e180";
var _a = "tutorial-scroll-0e180";
var _b = "wide-scroll-0e180";
export { _1 as "custom-scroll", _2 as "display-settings__body", _3 as "display-settings__header", _4 as "hidden-scroll", _5 as "rankscale", _6 as "settings__description", _7 as "settings__label", _8 as "settings__subtitle", _9 as "signup", _a as "tutorial-scroll", _b as "wide-scroll" }
